module.exports = __webpack_public_path__ + "assets/2599f21cb6fa91affc77cc1e9aded4a3.svg";